import { FC, ReactElement } from 'react';

import { RaaDialog } from 'raa-react';

import { AndamalTag } from 'models/appModels/AndamalTag';

const CategoryInfoDialog: FC<{ andamal: AndamalTag; unsetDialog: () => void }> = ({
  andamal,
  unsetDialog
}): ReactElement => {
  return (
    <RaaDialog header={andamal.namn} close={unsetDialog} ariaDescribedBy="dialog-description">
      <p id="dialog-description" className="tw-mt-8">
        {andamal.definitionstext}
      </p>
      {andamal.nyckelord.length > 0 && (
        <>
          <p className="tw-mt-2">Klassificeringen används även för:</p>
          <ul>
            {andamal.nyckelord.map((ord) => (
              <li key={ord.nyckelord_id}>{ord.nyckelord}</li>
            ))}
          </ul>
        </>
      )}
    </RaaDialog>
  );
};

export default CategoryInfoDialog;
